import React from 'react';

const DocumentList = ({ documents, singleUrl, singleName, label }) => {
  if (documents && documents.length > 0) {
    return (
      <div className="documents-list" style={{marginBottom: '8px'}}>
        {documents.map((doc, i) => (
          <div key={i} style={{marginBottom: '4px'}}>
            <a href={`https://www.secs.gismac.co.ke${doc.url}`} target="_blank" rel="noopener noreferrer" style={{fontSize: '13px', color: '#2563eb'}}>
              📄 {doc.name || 'Document ' + (i+1)}
            </a>
          </div>
        ))}
      </div>
    );
  }
  
  if (singleUrl) {
    return (
      <a href={`https://www.secs.gismac.co.ke${singleUrl}`} target="_blank" rel="noopener noreferrer" style={{fontSize: '13px', color: '#2563eb'}}>
        📄 {singleName || label || 'Document'}
      </a>
    );
  }
  
  return <span className="text-muted">No document attached</span>;
};

export default DocumentList;
